import Axios from './axiosClient'
import { API_ENDPOINT } from '../constants/apis'
import { AxiosResponse } from 'axios'
import type { JiraFeatureRolloutTicket, JiraIssue } from '../types'

export const getJiraIssue = (
  key: string
): Promise<AxiosResponse<JiraIssue | null>> => {
  return Axios.get(
    `${API_ENDPOINT}/jira/issue/${encodeURIComponent(key)}`
  )
}

export const searchFeatureRolloutTicket = (
  flagName: string
): Promise<AxiosResponse<JiraFeatureRolloutTicket | null>> => {
  return Axios.get(
    `${API_ENDPOINT}/jira/feature-rollout/${encodeURIComponent(flagName)}`
  )
}
